import { render, staticRenderFns } from "./LandingCode.vue?vue&type=template&id=0894089e&scoped=true&"
import script from "./LandingCode.vue?vue&type=script&lang=js&"
export * from "./LandingCode.vue?vue&type=script&lang=js&"
import style0 from "./LandingCode.vue?vue&type=style&index=0&id=0894089e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0894089e",
  null
  
)

export default component.exports